import React, { useCallback, useState } from 'react';
import MessageTextarea from './MessageTextarea';
import MessageCapsuleButtons from './MessageCapsuleButtons';
import { Button } from '../../../../../ui';

interface AddMessageFieldProps {
    message: string;
    handleDone: () => unknown;
    setMessage: (text: string) => unknown;
}

const AddMessageField: React.FC<AddMessageFieldProps> = ({
    message,
    setMessage,
    handleDone,
}) => {
    const inputRef = React.useRef<HTMLTextAreaElement>(null);
    const [text, setText] = useState<string>(message);
    const handleTextChange = useCallback(
        (text: string) => {
            setText((s) => {
                const newText = s + text;
                return newText.length > 140 ? s : newText;
            });
            inputRef.current?.focus();
        },
        [setText],
    );
    const onDone = () => {
        setMessage(text);
        handleDone();
    };
    return (
        <div className="flex flex-col gap-4 align-middle justify-center w-[412px] mobile:w-full">
            <div className="text-body-large text-center">Add Message</div>
            <MessageCapsuleButtons setMessage={handleTextChange} />
            <MessageTextarea
                inputRef={inputRef}
                message={text}
                onChange={setText}
                placeholder={'Send a message with your gift...'}
            />
            <Button
                id="add-message-done"
                onClick={onDone}
                className="w-full"
            >
                Done
            </Button>
        </div>
    );
};

export default AddMessageField;
